import {
  Snackbar as MuiSnackbar,
  type SnackbarProps as MuiSnackbarProps,
} from '@mui/material';

/**
 * @deprecated Do not use this component, Unify toasts are in progress.
 * Please reach out in #unify-design-system-support for a path forward.
 */
export const Snackbar = MuiSnackbar;
/**
 * @deprecated Do not use this component, Unify toasts are in progress.
 * Please reach out in #unify-design-system-support for a path forward.
 */
export type SnackbarProps = MuiSnackbarProps;
